import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { GetMenuItem$Params } from 'src/api/generated/fn/menu-v-2/get-menu-item';
import { RemoveMenuItem$Params } from 'src/api/generated/fn/menu-v-2/remove-menu-item';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { MenuItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-item-dto';
import { MenuV2Service } from 'src/api/generated/services';
import { MeasurementUnit } from 'src/app/pos-panel/enums/measurement-unit.enum';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-menu-item-details',
  templateUrl: './menu-item-details.component.html',
  styleUrls: ['./menu-item-details.component.scss']
})
export class MenuItemDetailsComponent implements OnInit, OnDestroy {

  unsubscribe: Subject<void> = new Subject<void>();
  menuItem: MenuItemDto = {} as MenuItemDto;
  imagePath: any = './assets/images/img-menu-item-image-placeholder.png';
  menuItemId: string;
  venueId: string;
  liter: string = MeasurementUnit.Liter;
  kilogram: string = MeasurementUnit.Kilogram;
  pieces: string = MeasurementUnit.Pieces;

  public venueIdUpdateSubscription: Subscription;
  currency: MenuCurrencyDto;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private menuV2Service: MenuV2Service,
    public currencyService: CurrencyService,
    private currentVenueHelper: CurrentVenueHelperService,
    private confirmationService: ConfirmationService,
    public translate: TranslateService
  ) {

    this.route.params.subscribe(params => {
      if (params['menu-item-id'] != null) {
        this.menuItemId = params['menu-item-id'];
      }
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
    });
    this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);
  }

  ngOnInit(): void {
    this.getMenuItem()
  }

  getMenuItem() {
    var params: GetMenuItem$Params = {} as GetMenuItem$Params;
    params.menuItemId = this.menuItemId;
    this.menuV2Service.getMenuItem(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.menuItem = response;
        },
        error: errorResponse => {
        }
      });
  }
  back() {
    this.router.navigate([this.venueId, "menuV2"], { queryParams: { activeIndex: 1 } });
  }
  editMenuItem(menuItem: MenuItemDto) {
    this.router.navigate([this.venueId, "menuV2", "edit-menu-item", menuItem.id]);
  }
  deleteMenuItem(menuItem: MenuItemDto) {    
    this.confirmationService.confirm({
      header: this.translate.instant('MENU_ITEM.DELETE_MENU_ITEM_TITLE') + "?",
      message: this.translate.instant('MENU_ITEM.DELETE_MENU_ITEM_TEXT') + menuItem.name + " ?",
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      closeOnEscape: false,
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        var params: RemoveMenuItem$Params = {} as RemoveMenuItem$Params;
        if (menuItem.id) {
          params.menuItemId = menuItem.id;
        }
       
        this.menuV2Service.removeMenuItem(params)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.router.navigate([this.venueId, "menuV2"], { queryParams: { activeIndex: 1 } });
            },
            error: errorResponse => {
            }
          });
      }
    });
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
